import React from 'react'
import DocumentTitle from 'react-document-title'

export default class Photos extends React.Component {
	render() {
		return (
			<DocumentTitle title='Photos'>
				<article className='content'>
					<h2 className='title'>Photos</h2>
					<p>We had a great time at our wedding, and got some amazing photos of it! Here are the photos people have shared with us, and instructions on how to share your own!</p>

					<h3 className='subsection'>Wedding Photos</h3>
					<p>The wonderful and talented <a href='https://www.aliwalkerphoto.com' title='Ali Walker'>Ali Walker</a> was our photographer for the event, and she got some great photos of it. You can view and/or download the high-resolution files <a href='https://carvers.link/wedding/photos' title='Wedding Photos on Google Photos'>from Google Photos</a>.</p>

					<p>And, of course, our guests took some photos, and were kind enough to <a href='#share' title='Share your photos with us'>share them with us</a>. You can find those in the <a href='https://carvers.link/wedding/guestphotos' title='Shared Photo Album'>shared Google Photos album</a>.</p>

					<h3 className='subsection'>Wedding Videos</h3>
					<p>Our friend Kristie took video of a lot of the wedding; you can view it <a href='https://carvers.link/wedding/videos' title='Videos on YouTube'>on YouTube</a>.</p>

					<h3 className='subsection'>Engagement Photos</h3>
					<p>Our engagement photo shoot photos are available in high resolution digital files as a <a href='https://carvers.link/engagementphotos' title='Engagement Photos on Google Photos'>Google Photos album</a>. They were taken by the amazing <a href='https://www.aliwalkerphoto.com' title='Ali Walker Photography'>Ali Walker</a>.</p>

					<h3 className='subsection'>Honeymoon Photos</h3>
					<p>We took a <em>lot</em> of pictures on the honeymoon (though, spoilers, they're mostly of animals.) To see them, check out the shared albums below. There were so many pictures, we had to split them up into six albums:</p>
					<ul>
						<li><a href='https://carvers.link/honeymoonpics1' title='First Album of Honeymoon Pictures'>First album</a></li>
						<li><a href='https://carvers.link/honeymoonpics2' title='Second Album of Honeymoon Pictures'>Second album</a></li>
						<li><a href='https://carvers.link/honeymoonpics3' title='Third Album of Honeymoon Pictures'>Third album</a></li>
						<li><a href='https://carvers.link/honeymoonpics4' title='Fourth Album of Honeymoon Pictures'>Fourth album</a></li>
						<li><a href='https://carvers.link/honeymoonpics5' title='Fifth Album of Honeymoon Pictures'>Fifth album</a></li>
						<li><a href='https://carvers.link/honeymoonpics6' title='Sixth Album of Honeymoon Pictures'>Sixth album</a></li>
					</ul>

					<h3 className='subsection'>Social Media</h3>
					<p>We&rsquo;re using the hashtag &ldquo;#paddyandethan&rdquo; to track tweets, Facebook posts, and Instagram pictures for the wedding. If you can, tagging your stuff with that really helps us find everything.</p>

					<h3 className='subsection' id='share'>Sharing Your Photos With Us</h3>
					<p>We&rsquo;d <em>love</em> to gather as many pictures as we can of our wedding. Feel free to <a href='mailto:grooms@carvers.co' title='mail to Paddy and Ethan'>email your photos to us</a>. A slightly easier method is to just upload them to our <a href='https://carvers.link/wedding/guestphotos' title='Our shared Google Photos album'>shared Google Photos album</a>. All you need is a Google account.</p>
					<ol>
						<li>For photos on your phone, <a href='https://photos.google.com/apps' title='Google Photos apps'>download the Google Photos app</a>. If you're on your computer, head to <a href='https://photos.google.com'>photos.google.com</a>.</li>
						<li>Sign in.</li>
						<li>Upload the photos you want to add to our shared album.</li>
						<li>Click the link for our <a href='https://carvers.link/wedding/guestphotos' title='Our shared Google Photos album'>shared Google Photos album</a>.</li>
						<li>Hit the plus sign in the top menu and select the photos you want to share.</li>
					</ol>
				</article>
			</DocumentTitle>
		)
	}
}



// WEBPACK FOOTER //
// ./client/components/Photos/index.jsx